import { render, staticRenderFns } from "./salto.vue?vue&type=template&id=9dece87e&scoped=true&lang=pug&"
import script from "./salto.vue?vue&type=script&lang=js&"
export * from "./salto.vue?vue&type=script&lang=js&"
import style0 from "./salto.vue?vue&type=style&index=0&id=9dece87e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dece87e",
  null
  
)

export default component.exports